import { render, staticRenderFns } from "./product-vitrine.vue?vue&type=template&id=5e72e3f4"
import script from "./product-vitrine.vue?vue&type=script&lang=ts"
export * from "./product-vitrine.vue?vue&type=script&lang=ts"
import style0 from "./product-vitrine.vue?vue&type=style&index=0&id=5e72e3f4&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e72e3f4')) {
      api.createRecord('5e72e3f4', component.options)
    } else {
      api.reload('5e72e3f4', component.options)
    }
    module.hot.accept("./product-vitrine.vue?vue&type=template&id=5e72e3f4", function () {
      api.rerender('5e72e3f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/product-vitrine.vue"
export default component.exports